import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { UserService } from '../../user/user.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LinkedinService {
  private linkedInAuthUrl = 'https://www.linkedin.com/oauth/v2/authorization';
  private clientId = '862q1810h8jrro';
  private redirectUri: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService,
    private router: Router
  ) {
    this.redirectUri =
      typeof window !== 'undefined' ? window.location.origin + '/login' : '';
  }

  loginWithLinkedIn(): void {
    const state = this.generateState();
    const authUrl = `${this.linkedInAuthUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}&scope=openid%20profile%20email&state=${state}`;

    if (typeof window !== 'undefined') {
      const popup = window.open(
        authUrl,
        'LinkedIn Login',
        'width=600,height=600'
      );

      if (!popup) {
        alert('Popup blocked. Please allow popups for this site.');
        return;
      }

      const interval = setInterval(() => {
        try {
          const url = popup.location.href;
          if (url.indexOf(this.redirectUri) === 0) {
            const code = this.extractCodeFromUrl(url);
            if (code) {
              clearInterval(interval);
              popup.close();
              this.exchangeCodeForToken(code);
            }
          }
        } catch {}
      }, 1000);
    }
  }

  private extractCodeFromUrl(url: string): string | null {
    const params = new URLSearchParams(url.split('?')[1]);
    return params.get('code');
  }

  private exchangeCodeForToken(code: string): void {
    this.authService.loginAsLinkedIn(code).subscribe({
      next: (response: any) => {
        // ✅ لو الـ response مش Object (يعني Error message string)
        if (typeof response === 'string') {
          console.error('❌ LinkedIn login failed:', response);
          return;
        }

        // ✅ تأمين الحقول
        response.picture = response.picture || response.profileImage || null;

        this.userService.setTokenInfo(
          response.accessToken,
          response.refreshToken,
          response.userId,
          response.role
        );
        this.userService.getUserData().subscribe({
          next: (res: any) => {
            this.userService.setUserInfo({
              ...response,
              picture:
                res.pictureUrl ||
                response.picture ||
                response.profileImage ||
                null,
            });
          },
        });

        const redirectUrl = localStorage.getItem('redirectUrl') || '/';
        localStorage.removeItem('redirectUrl');
        this.router.navigate([redirectUrl]);
      },
      error: (err) => {
        console.error('❌ LinkedIn login request error:', err);
      },
    });
  }

  private generateState(): string {
    return Math.random().toString(36).substring(7);
  }
}
